import React from 'react';

const SvgLinkedIn = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    {...props}
  >
    <path
      d="M14.5 0H2.5C1.4 0 .5.9.5 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2ZM5.46 13.64H2.93V6h2.53v7.64Zm-1.27-8.68a1.47 1.47 0 1 1 0-2.93 1.47 1.47 0 0 1 0 2.93ZM14.07 13.64h-2.53v-3.72c0-.89-.02-2.03-1.24-2.03-1.24 0-1.43.97-1.43 1.97v3.78H6.34V6h2.43v1.04h.03c.34-.64 1.17-1.32 2.4-1.32 2.57 0 3.04 1.69 3.04 3.89v4.03h-.17Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgLinkedIn;
